import { mapState } from "vuex";
import Vue from "vue";

Vue.mixin({
  metaInfo: {
    title: "TOUR Championship Golf Ball",
    htmlAttrs: {
      lang: "en",
      amp: true,
    },
    meta: [
      {
        vmid: "description",
        name: "description",
        content: "TOUR Championship Golf Ball",
      },
    ],
  },
  methods: {
    $alert(message, type = "default") {
      this.$root.$emit("alert", {
        message,
        type,
      });
    },
    updateResource(resourceName, handler, _data) {
      let data = _data;
      if (handler) data = handler(data);

      this.$store.commit("page/cache", {
        [this.activePage?.id]: {
          [resourceName]: data,
        },
      });

      return data;
    },
    async fetchResource(resourceName, handler) {
      let { data } = await this.$api[resourceName].query({
        page_id: this.activePage?.id,
      });

      return this.updateResource(resourceName, handler, data);
    },
    async setPageContext(name, callback) {
      const page = this.$store.getters["page/list"].find((s) => s.slug == name);
      this.$store.commit("page/setActive", page);

      await this.$nextTick();
      await this.$nextTick();
      if (callback) {
        callback();
      }
    },
  },
  computed: {
    ...mapState({
      token: (state) => state.auth.token,
      currentUser: (state) => state.user.current,
      pages: (state) => state.page.list,
      activePage: (state) => state.page.active,
      applidationLoaded: (state) => state.application.loaded,
      hidden: () => window.location.host == "tourgolfball.com",
      // hidden: () => window.location.host == "localhost:8080",
    }),
    $size() {
      return this.$vuetify.breakpoint.name;
    },
  },
});
